import { render, staticRenderFns } from "./ProductSales.vue?vue&type=template&id=7ad97c36"
import script from "./ProductSales.vue?vue&type=script&lang=js"
export * from "./ProductSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports